import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../../hook/Translation';


export default function ContentCard({ data, textAlign, pair = true, heigth, contentHeight, buttonHeight, containerStyle, price, target }) {
        const {t} = useTranslation();
    return (
        <Grid container spacing={{md: 8, xs:2}} position={'relative'} height={heigth ?? { md: 400, xs: 'auto' }} padding={{ md: 'unset', xs: '20px' }} flexDirection={data?.direction ?? {md: 'row', xs: 'column-reverse'}}>
            <Grid size={{ md: 6, xs: 12 }} position={{ md: 'relative', xs: 'unset' }} width={1} height={1} zIndex={{md: 'unset', xs: 1}} sx={{ opacity: { md: 1, xs: 1 } }} bgcolor={'#1E353D'}>
                {
                    data?.imageUrl &&
                    <Box component={'img'} src={data?.imageUrl} className='fitCover' width={1} height={{md: 1, xs: '100%'}} minHeight={{ md: 'unset', xs: 200}} />
                }
            </Grid>
            <Grid size={{md: 6, xs: 12}} zIndex={2}>
                <Grid container height={1} spacing={{md: 0, xs: 4}} sx={containerStyle}>
                    {
                        pair ?
                        (
                            <>
                                <Grid size={12} height={contentHeight ?? { md: '80%', xs: 'auto' }}>
                                    <Grid container gap={'38px'}>
                                        <Grid size={12}>
                                            <Typography textAlign={textAlign ?? 'start'} variant="body1" color="text.secondary" fontSize={{md: '1.125rem', xs: '1rem'}}  fontWeight={'bold'} mb={'15px'}>{data?.type}</Typography>
                                            <Typography textAlign={textAlign ?? 'start'} variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{md: '2.875rem', xs: '2rem'}} fontWeight={'bold'}>{data?.title}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Typography textAlign={textAlign ?? 'start'} sx={data?.descriptionStyle} variant="body1" color="text.secondary" fontSize={{md: '1rem', xs: '0.875rem'}}>{data?.description}</Typography>
                                        </Grid>
                                        {
                                            data?.price &&
                                        <Grid size={12}>
                                            <Typography textAlign={textAlign ?? 'start'} sx={data?.descriptionStyle} variant="body1" color="text.secondary" fontWeight={'bold'} fontSize={{md: '36px', xs: '2rem'}}>{data?.price}</Typography>
                                        </Grid>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid size={12} height={buttonHeight ?? { md: '20%', xs: 'auto' }}>
                                    <Grid container height={1} gap={{md: '25px', xs: '20px'}} alignItems={'flex-end'}>
                                        {
                                        data?.book &&
                                        <Grid size={{md: 'auto', xs: 12}}>
                                            <Button LinkComponent={Link} to={data?.book}  target={target ? target : '_self'} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                                 {t('book_now')}
                                            </Button>
                                        </Grid>
                                        }
                                        {
                                            data?.learn && 
                                            <Grid size={{md: 'auto', xs: 12}}>
                                                <Button LinkComponent={Link} to={data?.learn} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' color='text.secondary'>
                                                     {t('learn_more')}
                                                </Button>
                                            </Grid>
                                        }
                                        
                                    </Grid>
                                </Grid>
                            </>
                        )
                        :
                        (
                            <>
                                <Grid size={12} height={contentHeight ?? { md: '80%', xs: 'auto' }}>
                                    <Grid container spacing={{md: 4, xs: 3}}>
                                        <Grid size={12}>
                                            <Typography textAlign={textAlign ?? 'start'} variant="body1" color="text.secondary" fontSize={{md: '1.125rem', xs: '1rem'}} gutterBottom fontWeight={'bold'}>{data?.type}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Typography textAlign={textAlign ?? 'start'} gutterBottom variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{md: '2.875rem', xs: '2rem'}} fontWeight={'bold'}>{data?.title}</Typography>
                                            <Typography textAlign={textAlign ?? 'start'} sx={data?.descriptionStyle} variant="body1" color="text.secondary" fontSize={{md: '1rem', xs: '0.875rem'}}>{data?.description}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12} height={buttonHeight ?? { md: '20%', xs: 'auto' }}>
                                    <Grid container height={1} spacing={4} alignItems={'flex-end'} justifyContent={'center'}>
                                       {
                                        data?.book &&
                                        <Grid size={{md: 'auto', xs: 12}}>
                                            <Button LinkComponent={Link} to={data?.book} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                                {t('book_now')}
                                            </Button>
                                        </Grid>
                                        }
                                        
                                        {
                                            data?.learn && 
                                            <Grid size={{md: 'auto', xs: 12}}>
                                                <Button LinkComponent={Link} to={data?.learn} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' color='text.secondary'>
                                                     {t('learn_more')}
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}